import { combineReducers } from 'redux';
import envoiDevis from './envoidevis.reducer.js';

const reducer = combineReducers({
    envoiDevis,
});

export default reducer;
